import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
 // @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import logo2 from './logo2.png'

// ----------------------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();




  // OR
  const Logo = <Box component="img" src={logo2} sx={{ width: 220, height: 35, ...sx }} />

 

  if (disabledLink) {
    return <>{Logo}</>;
  }

  return <RouterLink to="/">{Logo}</RouterLink>;
}
